import z from 'zod'

export type SigninEmailMfaValidateObject = z.infer<
  typeof signinEmailMfaValidateObject
>

export const signinEmailMfaValidateObject = z.object({
  code: z
    .string()
    .refine((v) => /^[0-9]+$/.test(v), {
      message: '認証コードが未入力、または間違っています',
    })
    .pipe(
      z
        .string()
        .min(6, { message: '認証コードが未入力、または間違っています' })
        .max(6, { message: '認証コードが未入力、または間違っています' })
    ),
})
